import React from 'react';
import Heading from './Heading';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import { MdOutlineManageAccounts } from "react-icons/md"; 
import { FaUserTie, FaHeadset } from "react-icons/fa"; 
import homebackgroundimg from './../image/banner.png';

const ExperiencedProfessionals = ({ title }) => {

  const isconsultant = title === "Consulting with Nexify Clients";
  return (
    
    <div className="w-full h-auto bg-white flex flex-col items-center justify-center lg:mt-20 sm:mt-0">

   <div
        className="w-full h-[440px] bg-cover bg-center relative flex items-center justify-center"
        style={{ backgroundImage: `url(${homebackgroundimg})` }}
      >
        <div className="relative z-0 flex justify-center lg:justify-start items-center w-full px-4 sm:px-10 lg:px-20">
          <div
            className="opacity-0 translate-y-10 animate-slideUp bg-[#0c5495b3] p-6 shadow-lg text-white inline-block text-center lg:text-left max-w-[90%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[80%] lg:ml-14 border border-white/20 rounded-lg relative"
            style={{
              animation: "slideUp 1s ease-in-out forwards",
              animationDelay: "2s",
            }}
          >
            <h1 className="text-[8vw] md:text-[55px] font-semibold mb-2 break-words bg-gradient-to-r from-[#ffffff] to-[#39a0ff] text-transparent bg-clip-text relative z-10">
              Nexify Expanding Your Career
            </h1>
          </div>
        </div>
      </div>
      <div className="w-full max-w-[1320px] px-4 mx-auto mt-5 mb-5">

      <h2 className="mb-6 text-[#0e55a8] lg:text-[40px] text-[30px] leading-[1.2] font-[700] text-left">
        Expanding Your Career
      </h2>
      <div className="flex flex-col gap-6">
        {/* Sales Roles */}
        <div className="bg-white flex flex-col md:flex-row items-center p-6 ">
          <div className="flex items-center justify-center w-20 h-20 bg-[#cce5ff] rounded-full mr-6">
            <MdOutlineManageAccounts className="text-[#005eb8] text-5xl" />
          </div>
          <div className="flex-1">
            <h3 className="lg:text-[30px] text-[25px] leading-[1.25] text-[#363638] font-[700] mb-2">Sales Roles</h3>
            <p className="text-[#6d6d70] font-[400] text-[16px] leading-[1.8]">
              The Account Manager role is great for high-energy, motivated candidates with 1-2 years of experience 
              in an Outside Sales Representative role. They build relationships with our clients and ensure they’re 
              getting the candidate results they’re looking for. As our company continues to grow, new positions continue to evolve.
            </p>
          </div>
        </div>
        <div className="bg-white flex flex-col md:flex-row items-center p-6 ">
          <div className="flex items-center justify-center w-20 h-20 bg-[#cce5ff] rounded-full mr-6">
            <FaUserTie className="text-[#005eb8] text-5xl" />
          </div>
          <div className="flex-1">
            <h3 className="lg:text-[30px] text-[25px] leading-[1.25] text-[#363638] font-[700] mb-2">Consulting Services Roles</h3>
            <p className="text-[#6d6d70] font-[400] text-[18px] leading-[1.8]">
              We embrace the “New Normal” for IT Services by providing targeted professional services at lower costs 
              than traditional firms. Our team of seasoned consulting professionals leverages its experience and the 
              strengths of Nexify’s core recruiting business to outperform competitors.
            </p>
          </div>
        </div>
        <div className="bg-white flex flex-col md:flex-row items-center p-6 ">
          <div className="flex items-center justify-center w-20 h-20 bg-[#cce5ff] rounded-full mr-6">
            <FaHeadset className="text-[#005eb8] text-5xl" />
          </div>
          <div className="flex-1">
            <h3 className="lg:text-[30px] text-[25px] leading-[1.25] text-[#363638] font-[700] mb-2">Corporate and Customer Support Roles</h3>
            <p className="text-[#6d6d70] font-[400] text-[18px] leading-[1.8]">
              Our Best-in-Class support teams aid management and staff in their daily activities and help craft solutions 
              to address internal, contractor, and client needs. Positions are available in accounting, finance, 
              administration, HR, IT, and marketing.
            </p>
          </div>
        </div>
    
      </div>
    
      <div className="bg-white flex flex-col md:flex-row p-12 w-full max-w-[1320px] lg:text-center md:shadow-lg md:rounded-lg gap-20 mb-10 mt-10 justify-center items-center">
        {/* Left Side */}
        <div className="mb-2 md:mb-0 lg:text-center">
          <h3 className="lg:text-3xl text-2xl font-[500] text-black mt-2">Follow us for updates at #NexifyCareers</h3>
        </div>

        {/* Social Media Icons */}
        <div className="flex lg:justify-center lg:items-center lg:gap-6 gap-3 lg:mt-4 mt-[-10px] md:mt-0 ">

          <a
            href="https://www.linkedin.com/company/nexify-infosystems-llc"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-14 h-14 rounded-md bg-[#005eb8] text-white text-2xl"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="https://www.instagram.com/nexify_infosystems?igsh=MXZkN3loYWtiYmVpdw=="
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-14 h-14 rounded-md bg-[#005eb8] text-white text-2xl"
          >
            <FaInstagram />
          </a>
        </div>
      </div>
      </div>
    </div>
  );
};

export default ExperiencedProfessionals;
